import React from "react";
import PropTypes from "prop-types";
import { StatusBadge } from "../../../design-system";
import { getMessageStatusMeta } from "./messagesUtils";

/**
 * Scheduled / Sending / Sent / Failed / Suppressed / Cancelled pill with the
 * semantic StatusBadge tone per status (info / info / success / danger /
 * warning / neutral) and the status description as tooltip.
 */
const MessageStatusBadge = ({ status, size = "sm", className = "" }) => {
  const meta = getMessageStatusMeta(status);
  return (
    <StatusBadge variant={meta.tone} size={size} className={className} title={meta.description}>
      {meta.label}
    </StatusBadge>
  );
};

MessageStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
  className: PropTypes.string,
};

export default MessageStatusBadge;
